import React, { createContext } from 'react'
import {
  IManageContext,
  defaultManageContext,
} from '../hooks/useManage'
const ManageContext = createContext<IManageContext>(defaultManageContext)
export default ManageContext